import axios from "axios";

import { SolarEnergyDetailItem } from "components/forms/SolarEnergyDetail";
import { InstallationFieldDetailItem } from "components/forms/InstallationFieldDetail";
import { SolarPanelDetailsItem } from "components/forms/SolarPanelDetails";
import { InverterDetailsItem } from "components/forms/InverterDetails";

export const createGreenEnergy = async (
  token: string,
  floorId: string,
  solarData: SolarEnergyDetailItem,
  installationData: InstallationFieldDetailItem,
  panelData: SolarPanelDetailsItem,
  inverterData: InverterDetailsItem
) => {
  return axios.post(
    `${process.env.REACT_APP_API_PATH}/v2/green-energy`,
    {
      greenEnergyRequest: [
        {
          floor_id: floorId,
          fotovoltaic_system: solarData.hasPhotovoltaic,
          inverter_platform: solarData.platformId,
          login: solarData.email,
          password: solarData.password,
          coverage_area_installed: installationData.coverage_area_installed,
          coverage_guidance: installationData.coverage_guidance,
          slope_installation_side: installationData.slope_installation_side,
          installation_local_condition:
            installationData.installation_local_condition,
          area_available_installation:
            installationData.area_available_installation,
          location_pictures: installationData.location_pictures,
          fotovoltaic_panels_quantity: panelData.fotovoltaic_panels_quantity,
          fotovoltaic_panels_unit_power:
            panelData.fotovoltaic_panels_unit_power,
          fotovoltaic_panels_total_power:
            panelData.fotovoltaic_panels_total_power,
          fotovoltaic_panels_pictures: panelData.fotovoltaic_panels_pictures,
          solar_inverter_quantity: inverterData.solar_inverter_quantity,
          solar_inverter_unit_power: inverterData.solar_inverter_unit_power,
          solar_inverter_total_power: inverterData.solar_inverter_total_power,
          solar_inverter_pictures: inverterData.solar_inverter_pictures,
        },
      ],
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
